module.exports = __webpack_public_path__ + "img/gb.fd72d9b5.svg";